'use strict';

/**
 * @ngdoc service
 * @name webAgro1App.HistoricosService
 * @description
 * # HistoricosService
 * Factory in the webAgro1App.
 */

// eslint-disable-next-line max-len, max-lines-per-function, max-params
angular.module('webAgro1App').factory('HistoricosService', function($http, $q, Collections, filterFilter, $routeParams, ColorService) {
  return {
    list: function() {
      return $http.get(`${SERVER + API_VERSION }historicos`);
    },

    getHistoricos: function(propriedade) {
      return $http.get(`${SERVER + API_VERSION }historicos/${ propriedade}`);
    },

    confirmRead: function(propriedade) {
      return $http.delete(`${SERVER + API_VERSION }historicos/${ propriedade }/propriedade`);
    },

    listCulturas: function(filters) {
      return $http.get(`${SERVER }v1/all_historicos/culturas`, { params: filters });
    },

    listEstadios: function(filters) {
      const params = {
        cultura: (filters.cultura || {}).id || null,
        tipo: filters.tipo || null
      };
      return $http.get(`${SERVER }v1/all_historicos/estadios`, { params: params });
    },

    listOperacoes: function(filters) {
      return $http.get(`${SERVER }v1/all_historicos/tipos`, { params: filters }).then((result) => {
        result.data.push({
          id: 'inseto,doenca,invasora,nematoide,inimigo_natural',
          descricao: 'Monitoria'
        });
        result.data = _.sortBy(result.data, 'descricao');
        return $q.resolve(result);
      });
    },

    listOcorrencias: function(filters) {
      return $http.get(`${SERVER }v1/all_historicos/tipos_ocorrencias`, { params: filters });
    },

    listGruposInsumos: function(filters) {
      return $http.get(`${SERVER }v1/all_historicos/grupo_insumos`, { params: filters });
    },

    listGlebas: function(filters) {
      return $http.get(`${SERVER }v1/all_historicos/glebas`, { params: filters });
    },

    listUsuarios: function(filters) {
      return $http.get(`${SERVER }v1/all_historicos/usuarios`, { params: filters });
    },

    listCultivares: function(filters) {
      return $http.get(`${SERVER }v1/all_historicos/cultivares`, { params: filters });
    },

    getAllSelectFilters: function(filters) {
      const deffered = $q.defer();

      $q.all([
        this.listCulturas(filters),
        this.listOperacoes(filters),
        this.listGlebas(filters),
        this.listUsuarios(filters),
        this.listCultivares(filters)
      ]).then(function(result) {
        deffered.resolve({
          culturas: result[0].data,
          operacoes: result[1].data,
          glebas: result[2].data,
          usuarios: result[3].data,
          cultivares: result[4].data
        });
      }, deffered.reject);

      return deffered.promise;
    },

    getDatas: function(filters) {
      const deffered = $q.defer();

      $http.get(`${SERVER }v1/all_historicos/datas`, { params: filters }).then(function(result) {
        deffered.resolve({
          datas: result.data,
          meses: result.data.map(function(data) {
            return data.substring(0, 7);
          }),
          anos: result.data.map(function(data) {
            return data.substring(0, 4);
          })
        });
      }, deffered.reject);

      return deffered.promise;
    },


    // eslint-disable-next-line max-lines-per-function
    listCulturasDoPeriodo: function(data) {
      const deferred = $q.defer();
      const filters = {
        data: moment(data).format('Y-MM-DD')
      };

      // eslint-disable-next-line max-lines-per-function
      $http.get(`${SERVER }v1/all_historicos/cultura_historicos`, { params: filters }).then(function(result) {
        const porGleba = result.data.reduce(function(glebaResult, glebaCultura) {
          glebaResult[glebaCultura.gleba.id] = glebaResult[glebaCultura.gleba.id] || [];
          glebaResult[glebaCultura.gleba.id].push(glebaCultura.atividade);
          return glebaResult;
        }, {});

        const culturasPorGleba = Object.keys(porGleba).map(function(key) {
          return porGleba[key];
        })
          .reduce(function(culturasResult, item) {
            const ids = Collections.sortMapField(item, 'id');
            culturasResult[ids] = {
              descricao: Collections.sortMapField(item, 'descricao'),
              cor: `#${ Collections.mixColors(item, 'cor')}`,
              cursor: 'pointer'
            };

            return culturasResult;
          }, {});

        Object.keys(porGleba).forEach(function(gleba) {
          porGleba[gleba] = {
            cor: `#${ Collections.mixColors(porGleba[gleba], 'cor')}`,
            descricao: Collections.sortMapField(porGleba[gleba], 'descricao'),
            ids: (porGleba[gleba] || []).map(function(atividade) {
              return atividade.id;
            })
          };
        });

        const all = Object.keys(culturasPorGleba).map(function(key) {
          return culturasPorGleba[key];
        });
        deferred.resolve({
          all: all,
          porGleba: porGleba
        });
      }, deferred.reject);

      return deferred.promise;
    },

    // eslint-disable-next-line max-lines-per-function
    listCultivaresDoPeriodo: function(data) {
      const deferred = $q.defer();
      const filters = {
        data: moment(data).format('Y-MM-DD')
      };

      // eslint-disable-next-line max-lines-per-function
      $http.get(`${SERVER }v1/all_historicos/cultivar_historicos`, { params: filters }).then(function(result) {
        const porGleba = result.data.reduce(function(glebaResult, glebaCultivar) {
          glebaResult[glebaCultivar.gleba.id] = glebaResult[glebaCultivar.gleba.id] || [];
          const insumo = glebaCultivar.insumo;
          const randomCor = ColorService.getRandom();
          const atividadeCor = glebaCultivar.atividade.cor;
          if (typeof(atividadeCor) !== 'undefined' && atividadeCor !== null) {
            insumo.cor = Collections.mixTwoColors(atividadeCor, randomCor);
          } else {
            insumo.cor = randomCor;
          }

          glebaResult[glebaCultivar.gleba.id].push(insumo);
          return glebaResult;
        }, {});

        const cultivaresPorGleba = Object.keys(porGleba).map(function(key) {
          return porGleba[key];
        })
          .reduce(function(cultivaresResult, item) {
            const ids = Collections.sortMapField(item, 'item_id');
            cultivaresResult[ids] = {
              descricao: Collections.sortMapField(item, 'descricao'),
              cor: `#${ Collections.mixColors(item, 'cor')}`,
              cursor: 'pointer'
            };

            return cultivaresResult;
          }, {});

        Object.keys(porGleba).forEach(function(gleba) {
          const ids = (porGleba[gleba] || []).map(function(insumo) {
            return insumo.item_id;
          });
          const key = ids.sort().join(', ');
          const cultivarPorGleba = cultivaresPorGleba[key];
          porGleba[gleba] = {
            ids,
            cor: cultivarPorGleba.cor,
            descricao: cultivarPorGleba.descricao
          };
        });

        const all = Object.keys(cultivaresPorGleba).map(function(key) {
          return cultivaresPorGleba[key];
        });

        deferred.resolve({
          all: all,
          porGleba: porGleba
        });
      }, deferred.reject);

      return deferred.promise;
    },

    // eslint-disable-next-line complexity
    getFilteredPeriod: function() {
      const result = {
        dataInicial: null,
        dataFinal: null,
        periodo: {}
      };

      const routeDate = $routeParams.historyDate || $routeParams.date;

      if ($routeParams.recommendationFilters) {
        const filters = JSON.parse($routeParams.recommendationFilters);
        result.dataInicial = filters.dataInicial || routeDate;
        result.dataFinal = filters.dataFinal || routeDate;
      } else if (routeDate) {
        result.dataInicial = routeDate;
        result.dataFinal = routeDate;
      }

      if (result.dataInicial) {
        if (result.dataInicial === result.dataFinal) {
          result.periodo.periodo = moment(result.dataInicial).format(DATE_FORMAT.toUpperCase());
        } else {
          const startDate = moment(result.dataInicial).format(DATE_FORMAT.toUpperCase());
          const endDate = moment(result.dataFinal).format(DATE_FORMAT.toUpperCase());

          result.periodo.periodo = `${startDate} à ${endDate}`;
        }
      }
      return result;
    }
  };
});
